import { useQuery, UseQueryOptions } from 'react-query';

import { Guid, RepositoryLink } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useSendDocumentLinkQuery(
	guid: Guid | undefined,
	documentGuid: Guid | undefined,
	options?: Omit<UseQueryOptions<RepositoryLink, unknown, RepositoryLink>, 'queryKey' | 'queryFn'> | undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.DataRoom.SendDocumentLink(guid, documentGuid),
		() =>
			AxiosUtils.getResponseData<RepositoryLink>(
				api.get(CerebroApiEndpoints.DataRooms.SendDocumentLink(guid, documentGuid))
			),
		options
	);
}
